import IconComponent from './IconComponent/IconComponent'

const TipItem = ({ icon, text }) => {
  return (
    <div className="d-flex align-items-center gap-3">
      <IconComponent icon={icon} />
      <span className="fontSize14 text-on-bg-primary">{text}</span>
    </div>
  )
}

export default TipItem
